export default {"src":"/_next/static/image/public/images/flags/flag_359.17748fcbfbf6aa8140b11ad94cc1d460.svg","height":16,"width":24};